import { render, staticRenderFns } from "./temperature.vue?vue&type=template&id=6399456d&scoped=true"
import script from "./temperature.vue?vue&type=script&lang=js"
export * from "./temperature.vue?vue&type=script&lang=js"
import style0 from "./temperature.vue?vue&type=style&index=0&id=6399456d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6399456d",
  null
  
)

export default component.exports